import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import _get from 'lodash/get';
import EmailCheck from '../../../../styledComponents/styles/EmailCheck.styled';
import GetLogo from '../../components/GetLogo';
import { NavLink } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ScreenReaderHeadingComponent from '../../../travelerProfile/components/heading/ScreenReaderHeadingComponent';
import SessionExpiredCard from './SessionExpired.card';

const Action = styled.div`
  color: #373737;
  font-size: 14px;
  font-weight: 400;
  line-height: 140%;

  a {
    color: #373737;
    font-weight: 600;
    text-decoration: underline;
  }
`;

const EmailLookup = styled.div`
  padding: 23px 10px 37px 10px;
  text-align: left;
  width: 100%;
`;

const Header = styled.span`
  color: #0b3544;
  font-size: 28px;
  font-weight: 600;
  line-height: 74px;
`;

const Instructions = styled.div`
  color: #373737;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
`;

export default function GetStartedForm() {
  const organization = useSelector(state => state.auth.organization);
  const [emailCheck, setEmailCheck] = useState();
  const [errorText, setErrorText] = useState('');
  const [allowSignup, setAllowSignUp] = useState(true);
  const [isSessionExpired, setIsSessionExpired] = useState(false);

  useEffect(() => {
    if (
      typeof window !== undefined &&
      localStorage &&
      localStorage.getItem('is_session_expired') &&
      localStorage.getItem('is_session_expired') === '1'
    ) {
      setIsSessionExpired('1');
      localStorage.removeItem('is_session_expired');
    } else {
      // console.log("condition not matched");
    }
  }, []);

  useEffect(() => {
    if (emailCheck) {
      setErrorText('');
      setTimeout(() => {
        if (!emailCheck.loading && !emailCheck.error && emailCheck.data) {
          setErrorText('');
          const parts = window.location.host.split('.');
          const subdomain = parts[0];
          const newSubdomain = _get(emailCheck, 'data.client_account.subdomain') || subdomain;
          let root = [...parts];
          root.shift();
          root = root.length > 0 ? root.join('.') : parts[0];
          const rootUrl = `${window.location.protocol}//${newSubdomain}.${root}`;

          window.location = `${rootUrl}/authV2/welcome?email=${encodeURIComponent(emailCheck.searchedEmail)}`;
        } else {
          setErrorText('Unable to retrieve account. Try again');
        }
      }, 1);
    }
  }, [emailCheck]);

  useEffect(() => {
    if (organization && organization.info) {
      setAllowSignUp(organization.info.allow_traveler_sign_up);
    }
  }, [organization]);

  return (
    <>
      <GetLogo />
      <ScreenReaderHeadingComponent text={`Let’s get started`} />
      <Header>Let’s get started</Header>
      <Instructions>Sign in to your account</Instructions>
      <EmailLookup>
        <EmailCheck
          buttonText={'Sign In'}
          customErrorMsg={errorText}
          id={'email'}
          onClick={value => setEmailCheck(value)}
          placeholder={'Enter your email'}
          label={'Enter your email'}
          required={true}
        />
      </EmailLookup>
      {allowSignup && (
        <Action>
          Don’t have an account? <NavLink to="/traveler/sign_up">Sign up</NavLink>
        </Action>
      )}

      {isSessionExpired && <SessionExpiredCard />}
    </>
  );
}
